import { render, staticRenderFns } from "./CampaignTable.vue?vue&type=template&id=3e5ec216&"
import script from "./CampaignTable.vue?vue&type=script&lang=js&"
export * from "./CampaignTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignTable.vue?vue&type=style&index=0&id=3e5ec216&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports